export default __webpack_public_path__ + "images/9cdd47b60f6e4f0937b23ef6ed757178-tankBullet5.png";